// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy {
    padding: 20px;
    font-family: "Roboto", sans-serif;
    line-height: 1.6;
    text-align: start !important;
    color: #fff; /* White text for better readability */
    /* background: linear-gradient(to bottom, #2e335a, #1c1b33); */
    /* border-radius: 8px; */
    /* margin: 20px; */
  }
  .logo-box-terms {
    display: flex;
    gap: 10px;
    /* cursor: pointer; */
    padding : 20px;
  }
  
  .logoImage-terms {
    height: 43px;
  }
  
  
  .privacy-policy h1 {
    color: white; /* Gold for the heading */
    font-size: 2.2rem;
    margin-bottom: 15px;
    text-align: start;
    margin-top: 0px !important;
  }
  
  .privacy-policy .effective-date {
    font-style: italic;
    margin-bottom: 20px;
    color: white; /* Light gold for dates or subheadings */
    text-align: start;
  }
  
  .privacy-policy h2 {
    color: white;
    font-size: 1.4rem;
    margin: 0px !important;
    /* border-bottom: 2px solid white; */
    padding-bottom: 5px;
  }
  
  .privacy-policy h3 {
    color: white;
    font-size: 1.2rem;
    margin-top: 10px !important;
  }
  
  .privacy-policy p {
    margin: 10px 0;
    font-size: 1rem;
    color: #f0f0f0; /* Slightly off-white for readability */
  }
  
  .privacy-policy ul {
    margin-left: 20px;
  }
  
  .privacy-policy ul li {
    margin-bottom: 10px;
    color: #f0f0f0;
  }
  
  .privacy-policy a {
    color: #00bcd4; /* Cyan for links */
    text-decoration: none;
    font-weight: bold;
  }
  
  .privacy-policy a:hover {
    text-decoration: underline;
  }
  
  /* .privacy-policy {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  } */

  ul {
    margin: 0px !important;
  }

  @media screen and (min-width: 1024px) {
    .privacy-policy{
      padding: 20px;
    }
     .logo-box-terms {
    padding : 20px;
  }
  }
  @media screen and (min-width: 1440px) {
    .privacy-policy{
      padding: 20px 280px;
    }
     .logo-box-terms {
    padding : 20px 40px;
  }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ShowcasaTerms/showcasaterms.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,4BAA4B;IAC5B,WAAW,EAAE,sCAAsC;IACnD,8DAA8D;IAC9D,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,YAAY,EAAE,yBAAyB;IACvC,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY,EAAE,wCAAwC;IACtD,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc,EAAE,uCAAuC;EACzD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc,EAAE,mBAAmB;IACnC,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;KAEG;;EAEH;IACE,sBAAsB;EACxB;;EAEA;IACE;MACE,aAAa;IACf;KACC;IACD,cAAc;EAChB;EACA;EACA;IACE;MACE,mBAAmB;IACrB;KACC;IACD,mBAAmB;EACrB;EACA","sourcesContent":[".privacy-policy {\n    padding: 20px;\n    font-family: \"Roboto\", sans-serif;\n    line-height: 1.6;\n    text-align: start !important;\n    color: #fff; /* White text for better readability */\n    /* background: linear-gradient(to bottom, #2e335a, #1c1b33); */\n    /* border-radius: 8px; */\n    /* margin: 20px; */\n  }\n  .logo-box-terms {\n    display: flex;\n    gap: 10px;\n    /* cursor: pointer; */\n    padding : 20px;\n  }\n  \n  .logoImage-terms {\n    height: 43px;\n  }\n  \n  \n  .privacy-policy h1 {\n    color: white; /* Gold for the heading */\n    font-size: 2.2rem;\n    margin-bottom: 15px;\n    text-align: start;\n    margin-top: 0px !important;\n  }\n  \n  .privacy-policy .effective-date {\n    font-style: italic;\n    margin-bottom: 20px;\n    color: white; /* Light gold for dates or subheadings */\n    text-align: start;\n  }\n  \n  .privacy-policy h2 {\n    color: white;\n    font-size: 1.4rem;\n    margin: 0px !important;\n    /* border-bottom: 2px solid white; */\n    padding-bottom: 5px;\n  }\n  \n  .privacy-policy h3 {\n    color: white;\n    font-size: 1.2rem;\n    margin-top: 10px !important;\n  }\n  \n  .privacy-policy p {\n    margin: 10px 0;\n    font-size: 1rem;\n    color: #f0f0f0; /* Slightly off-white for readability */\n  }\n  \n  .privacy-policy ul {\n    margin-left: 20px;\n  }\n  \n  .privacy-policy ul li {\n    margin-bottom: 10px;\n    color: #f0f0f0;\n  }\n  \n  .privacy-policy a {\n    color: #00bcd4; /* Cyan for links */\n    text-decoration: none;\n    font-weight: bold;\n  }\n  \n  .privacy-policy a:hover {\n    text-decoration: underline;\n  }\n  \n  /* .privacy-policy {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  } */\n\n  ul {\n    margin: 0px !important;\n  }\n\n  @media screen and (min-width: 1024px) {\n    .privacy-policy{\n      padding: 20px;\n    }\n     .logo-box-terms {\n    padding : 20px;\n  }\n  }\n  @media screen and (min-width: 1440px) {\n    .privacy-policy{\n      padding: 20px 280px;\n    }\n     .logo-box-terms {\n    padding : 20px 40px;\n  }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
